export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('goods_label_orderGoodsNo') || '订单产品编号',
    field: 'orderGoodsNo',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_label_identifyGoodsNo') || '识别编号',
    field: 'identifyGoodsNo',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_label_orderGoodsName') || '订单产品名称',
    field: 'orderGoodsDisplayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_label_qty') || '数量',
    field: 'qty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      enabled: that.packingType !== 'B',
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 1,
        precision: 0,
      },
    },
  },
  {
    title: that.$l('goods_label_inPackageQty') || '装箱入数',
    field: 'inPackageQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_label_boxQty') || '箱数',
    field: 'boxQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
